import { datadogRum } from '@datadog/browser-rum';

export function initTracking({
  applicationId,
  clientToken,
  service,
  env,
}: {
  applicationId: string;
  clientToken: string;
  service: string;
  env: string;
}) {
  if (!__RUNTIME.isProduction) return;

  datadogRum.init({
    applicationId,
    clientToken,
    service,
    env,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.eu',
    version: __RUNTIME.version,
    trackUserInteractions: false,
    trackResources: false,
    trackLongTasks: false,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

export function setUserForTracking(id: string, name: string) {
  if (!__RUNTIME.isProduction) return;

  datadogRum.setUser({ id, name });
}

export function clearUserForTracking() {
  if (!__RUNTIME.isProduction) return;

  datadogRum.clearUser();
}

export function addError(e: Error, context?: object) {
  if (__RUNTIME.isProduction) {
    datadogRum.addError(e, context);
  } else {
    console.error(e, context);
  }
}

// Пользовательское событие RUM: в Datadog ищется как custom action. Вне прода никуда
// не идет: консоль остается чистой
export function addAction(name: string, context?: object) {
  if (__RUNTIME.isProduction) datadogRum.addAction(name, context);
}
